// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3rg71","col":"styles_col__1xx6s","actions":"styles_actions__2sfiP","conflict":"styles_conflict__3TzOP"};